import { signal } from '@preact/signals-react';

import type { EnclosingNote } from 'features/insights/components/enclosing-notification-bar/types';

export const isFetchReportCachedSignal = signal(true);

export const enclosingNotesSignal = signal<EnclosingNote[] | undefined>(undefined);

export const shouldAbortFetchReportSignal = signal(false);

export const showUnsupportedFilterSignal = signal(false);
